// 역할 정의
export const ROLES = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    PM: 'pm',
    USER: 'user',
    FINANCE: 'finance',
};

/**
 * 사용자가 특정 역할을 가지고 있는지 확인 ⭐
 */
export const hasRole = (user, role) => {
    if (!user) return false;

    // 1. roles 배열/문자열 체크
    if (user.roles) {
        let rolesArray = [];

        // 배열인 경우
        if (Array.isArray(user.roles)) {
            rolesArray = [...user.roles];  // ← [...] 추가
        }
        // JSON 문자열인 경우
        else if (typeof user.roles === 'string') {
            try {
                rolesArray = JSON.parse(user.roles);
            } catch (e) {
                console.error('roles 파싱 실패:', e);
                return false;
            }
        }

        // 배열에서 역할 확인
        if (Array.isArray(rolesArray) && rolesArray.includes(role)) {
            return true;
        }
    }

    // 2. role 단일 값 체크
    if (user.role === role) {
        return true;
    }

    return false;
};


/**
 * 사용자가 여러 역할 중 하나라도 가지고 있는지 확인
 */
export const hasAnyRole = (user, ...roles) => {
    return roles.some(role => hasRole(user, role));
};

/**
 * 사용자가 모든 역할을 가지고 있는지 확인
 */
export const hasAllRoles = (user, ...roles) => {
    return roles.every(role => hasRole(user, role));
};

/**
 * 사용자의 모든 역할 가져오기
 */
/**
 * 사용자의 모든 역할 가져오기
 */
export const getUserRoles = (user) => {
    if (!user) return [];

    let rolesArray = [];

    // roles 파싱
    if (user.roles) {
        if (Array.isArray(user.roles)) {
            rolesArray = [...user.roles];  // ← [...] 추가
        } else if (typeof user.roles === 'string') {
            try {
                rolesArray = JSON.parse(user.roles);
            } catch (e) {
                console.error('roles 파싱 실패:', e);
            }
        }
    }

    // role 단일 값 추가
    if (user.role && !rolesArray.includes(user.role)) {
        rolesArray.push(user.role);
    }

    return rolesArray;
};

/**
 * 기능 권한 체크
 */
export const hasFeaturePermission = (user, feature) => {
    const permissions = FEATURE_PERMISSIONS[feature];
    if (!permissions) return false;

    return hasAnyRole(user, ...permissions);
};

// 기능별 권한 설정
export const FEATURE_PERMISSIONS = {
    // 프로젝트 관련
    createProject: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    editProject: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    deleteProject: [ROLES.ADMIN],
    viewAllProjects: [ROLES.ADMIN, ROLES.MANAGER],
    viewOwnProjects: [ROLES.PM, ROLES.USER],

    // 인력 투입 관련
    addProjectMember: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    removeProjectMember: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    reallocateHours: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],

    // 작업 일지 관련
    createWorkLog: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM, ROLES.USER],
    approveWorkLog: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    viewAllWorkLogs: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    viewOwnWorkLogs: [ROLES.USER],

    // 경비 관련
    createExpense: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM, ROLES.USER],
    pmApproveExpense: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
    financeApproveExpense: [ROLES.ADMIN, ROLES.FINANCE],
    viewAllExpenses: [ROLES.ADMIN, ROLES.MANAGER, ROLES.FINANCE],
    viewOwnExpenses: [ROLES.USER],

    // 사용자 관리
    createUser: [ROLES.ADMIN, ROLES.MANAGER],
    editUser: [ROLES.ADMIN, ROLES.MANAGER],
    deleteUser: [ROLES.ADMIN],

    // 부서 관리
    manageDepartments: [ROLES.ADMIN],

    // 보고서
    viewFinancialReports: [ROLES.ADMIN, ROLES.FINANCE],
    viewDepartmentReports: [ROLES.ADMIN, ROLES.MANAGER],
    viewProjectReports: [ROLES.ADMIN, ROLES.MANAGER, ROLES.PM],
};

// 역할 표시 이름
export const ROLE_NAMES = {
    [ROLES.ADMIN]: '시스템 관리자',
    [ROLES.MANAGER]: '부서장',
    [ROLES.PM]: 'PM',
    [ROLES.USER]: '일반 사원',
    [ROLES.FINANCE]: '재무담당',
};